import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-i02" }
const _hoisted_5 = { class: "p-the-page-i02__inner" }
const _hoisted_6 = { class: "p-the-page-i02__image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_IconTrophy = _resolveComponent("IconTrophy")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_TheTemplateI = _resolveComponent("TheTemplateI")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheTemplateI, {
          heading: "付与基準一覧",
          "indicated-item": []
        }, {
          contents: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_IconBase, {
                    width: _ctx.iconSize,
                    height: _ctx.iconSize,
                    "view-box": "0 0 70 70",
                    "icon-color": "#c4c4c4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconTrophy)
                    ]),
                    _: 1
                  }, 8, ["width", "height"])
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "p-the-page-i02__body" }, [
                  _createElementVNode("div", { class: "p-the-page-i02__body__text" }, [
                    _createElementVNode("p", null, " 付与基準の登録がありません。 ")
                  ])
                ], -1))
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}